import { useInstallerContext } from '../context/InstallerContext';
import { useEffect } from 'react';
import { useHandleInstallationValidations } from './useHandleInstallationValidations';
import { useHandlePostInstallation } from './useHandlePostInstallation';
import { useModals } from '../context/ModalsContext';
import { useRenderControl } from '../context/InstallerRenderControlContext';
import { Modals } from '../types';
import { shouldShowConsent } from '../utils/shouldShowConsent';
import { useProvisionApp } from './useProvisionApp';
import { useShouldOpenNewWindow } from './useShouldOpenNewWindow';
import { useNewWindowHandlers } from '../context/NewWindowHandlersContext';
export const useInstallationFlow = () => {
  const {
    modals,
    setActiveModal
  } = useModals();
  const newWindowHandlers = useNewWindowHandlers();
  const {
    prerequisitesState,
    setInstallerUiReady
  } = useRenderControl();
  const {
    preInstallationData,
    onInstallationCompleted
  } = useInstallerContext();
  const provisionAppApi = useProvisionApp();
  const handleInstallationValidations = useHandleInstallationValidations();
  const handlePostInstallation = useHandlePostInstallation();
  const shouldOpenNewWindow = useShouldOpenNewWindow();
  const {
    app,
    isAdvancedOauthApp,
    consentPermissions,
    shouldShowBlocksLegacyConsent
  } = preInstallationData;
  useEffect(() => {
    if (prerequisitesState.isDetermined) {
      (async () => {
        await handleInstallationValidations();
        if (app) {
          if (shouldShowConsent(consentPermissions, shouldShowBlocksLegacyConsent)) {
            await modals.userConsent.open({
              shouldOpenNewWindow
            });
          } else {
            setInstallerUiReady();
          }
          if (shouldOpenNewWindow) {
            setActiveModal(Modals.goToOtherTab);
            newWindowHandlers.openNewWindow();
            if (isAdvancedOauthApp) {
              // advanced oauth app gets a progress bar only after first redirect in useOauthBroadcastRedirectHandler
              newWindowHandlers.showSpinningLoader();
            } else {
              newWindowHandlers.showProgressBar();
            }
          } else {
            setActiveModal(Modals.installingLoader);
          }
          const provisionSuccessData = await provisionAppApi();
          if (provisionSuccessData) {
            await handlePostInstallation(provisionSuccessData, shouldOpenNewWindow);
            onInstallationCompleted(provisionSuccessData);
          }
        }
      })();
    }
  }, [app, prerequisitesState.isDetermined]);
};
//# sourceMappingURL=useInstallationFlow.js.map